import { makeStyles, Theme } from '@material-ui/core/styles';
import { THEME_MODES } from 'src/theming';

export const useSgiffoxxkStyle = makeStyles((theme: Theme) => {
    const isDarkMode = THEME_MODES.DARK === theme.palette.type;
    return {
        pageContainer: {
            height: '100%',
            alignContent: 'flex-start',
            padding: `0 140px`,
            backgroundColor: theme.palette.primary.main,
            [theme.breakpoints.down('lg')]: {
                padding: `0 ${theme.spacing(1)}px`,
            },
        },
        titleContainer: {
            width: '100%',
            height: 75,
            alignItems: 'center',
            [theme.breakpoints.down('lg')]: {
                height: 50,
            },
        },
        backButton: {
            width: 50,
            height: 50,
            marginRight: theme.spacing(2),
            backgroundColor: isDarkMode
                ? 'rgba(0, 0, 0, 0)'
                : theme.palette.secondary.main,
            border: isDarkMode
                ? `1px solid ${theme.palette.primary.contrastText}`
                : 'none',
            borderRadius: 5,
            transition: '0.2s',
            '&:hover': {
                backgroundColor: isDarkMode
                    ? 'rgba(0, 0, 0, 0)'
                    : theme.palette.secondary.main,
                opacity: 0.8,
            },
            '& .MuiSvgIcon-root': {
                width: 40,
                height: 30,
                color: theme.palette.secondary.contrastText,
            },
            [theme.breakpoints.down('md')]: {
                width: 40,
                height: 40,
                '& .MuiSvgIcon-root': {
                    width: 25,
                    height: 25,
                },
            },
        },
        title: {
            color: theme.palette.primary.contrastText,
            fontWeight: theme.typography.fontWeightMedium,
        },
        cardsContainer: {
            height: '90%',
            '&>div': {
                width: '50%',
            },
        },
        card: {
            backgroundColor: theme.palette.primary.light,
        },
        header: {
            flexDirection: 'row',
            width: '100%',
        },
        cardTitle: {
            fontSize: '1.8rem',
            color: !isDarkMode
                ? theme.palette.secondary.main
                : theme.palette.secondary.contrastText,
        },
        menuIcon: {
            width: 20,
            height: 20,
            color: theme.palette.secondary.contrastText,
        },
        additionalMenuButton: {
            width: 40,
            height: 40,
            borderRadius: 5,
            backgroundColor: theme.palette.info.light,
            transition: '0.2s',
            '&:hover': {
                backgroundColor: theme.palette.info.light,
                opacity: 0.8,
            },
        },
        list: {
            width: '40%',
            '& .MuiListItem-root': {
                padding: `${theme.spacing(1)}px ${theme.spacing(1)}px ${theme.spacing(
                    1
                )}px ${theme.spacing(2)}px`,
            },
            '& .MuiListItemText-root': {
                width: '100%',
                display: 'flex',
                margin: 0,
                wordBreak: 'break-all',
                color: theme.palette.primary.contrastText,
                '&[data-title]': {
                    opacity: 0.8,
                },
                '&[data-value]': {
                    paddingLeft: theme.spacing(2),
                },
            },
            '& .MuiTypography-root': {
                fontSize: '1.6rem',
            },
        },
        tableContainer: {
            width: '100%',
            height: '90%',
            paddingTop: theme.spacing(5),
        },
        dateSearchFieldClass: {
            '& .MuiInputBase-root': {
                display: 'none',
            },
        },
    };
});

export const usePaperSgiffoxxkStyle = makeStyles((theme: Theme) => {
    const isLightMode = THEME_MODES.LIGHT === theme.palette.type;
    return {
        root: {
            display: 'flex',
            flexWrap: 'wrap',
            alignContent: 'flex-start',
            height: '100%',
            padding: theme.spacing(4),
            borderRadius: 4,
            border: `1px solid ${
                !isLightMode ? theme.palette.grey['400'] : theme.palette.grey['200']
            }`,
            backgroundColor: theme.palette.primary.light,
            boxShadow: 'none',
        },
    };
});
